import React from "react";
// react admin
import { useGetIdentity } from "react-admin";
// mui
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Stack,
  Avatar,
  Skeleton,
} from "@mui/material";

export const BasicInfo = () => {
  const { isPending, data } = useGetIdentity();

  // svg icons
  const UserImage = "/Assets/Images/user.png";
  const Permissions = "/Assets/Icons/permissions.svg";
  const CheckmarkSquare = "/Assets/Icons/checkmark-square.svg";

  const rawData = [
    {
      id: 1,
      name: "Admin ID",
      value: data?.userId || "---",
      color: "#fff",
    },
    {
      id: 2,
      name: "Username",
      value: data?.username || "---",
      color: "#fff",
    },
    {
      id: 3,
      name: "Email",
      value: data?.email || "---",
      color: "#fff",
    },
    {
      id: 4,
      name: "Phone",
      value: data?.phone || "---",
      color: "#fff",
    },
    {
      id: 5,
      name: "Role",
      value: data?.userRoleName || "---",
      color: "#FFD700",
    },
    {
      id: 6,
      name: "Status",
      value: "Active",
      color: "#18DC8B",
      icon: CheckmarkSquare,
    },
  ];

  return (
    <React.Fragment>
      {isPending ? (
        <Card
          variant="outlined"
          sx={{
            mt: 2,
            backgroundColor: "#242424",
            borderRadius: "8px",
          }}
        >
          <CardContent>
            <Skeleton
              width="100%"
              height={100}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
          </CardContent>
        </Card>
      ) : (
        <Card
          variant="outlined"
          sx={{
            mt: 2,
            backgroundColor: "#242424",
            borderRadius: "8px",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#FFF",
                  fontSize: 18,
                  fontWeight: 400,
                }}
              >
                Basic Information
              </Typography>
              <Box
                sx={{
                  backgroundColor: "rgba(255, 215, 0, 0.20)",
                  padding: "8px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={Permissions}
                  alt={Permissions}
                  style={{ width: 24, height: 24 }}
                />
              </Box>
            </Box>

            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Avatar
                alt="Remy Sharp"
                src={UserImage}
                sx={{ width: "64px", height: "64px" }}
              />
            </Stack>

            <Grid container spacing={1}>
              {rawData?.map((ele, index) => (
                <Grid item xs={12} sm={6} md={6} key={index + 1}>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#999",
                        fontSize: 14,
                        fontWeight: 400,
                        mt: 2,
                      }}
                    >
                      {ele?.name}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {ele?.icon && (
                        <img
                          src={ele?.icon}
                          alt={index + 1}
                          style={{ width: 18, height: 18 }}
                        />
                      )}
                      <Typography
                        variant="span"
                        sx={{
                          color: ele?.color,
                          fontSize: 14,
                          fontWeight: 400,
                          ml: ele?.icon ? 1 : 0,
                        }}
                      >
                        {ele?.value}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      )}
    </React.Fragment>
  );
};
